import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import SimpleSwitch from "../../../../components/Widgets/SimpleSwitch";
import { SettingsSectionProps } from "./constants";

type BooleanSetting = {
  field: string;
  title: string;
  hint: string;
  // What the clock runs with while the field is unset — same defaults as
  // syncedSettings.ts.
  fallback: boolean;
};

const SECTIONS: { title: string; settings: BooleanSetting[] }[] = [
  {
    title: "Filters",
    settings: [
      {
        field: "showPSF",
        title: "Show Photo Sensitive content",
        hint: "Off filters photo-sensitive klydos out",
        fallback: true,
      },
      {
        field: "show13Plus",
        title: "Show 13+ content",
        hint: "Off filters 13+ klydos out",
        fallback: true,
      },
    ],
  },
  {
    title: "ECO Mode",
    settings: [
      {
        field: "ecoModeEnabled",
        title: "Automatic ECO Mode",
        hint: "Dims the clock when nobody is around",
        // Off since firmware 641.7; older firmware runs it on while unset.
        fallback: false,
      },
    ],
  },
  {
    title: "Dev",
    settings: [
      {
        field: "isRetail",
        title: "Retail Mode",
        hint: "Store display unit",
        fallback: false,
      },
      {
        field: "isPreHandledEditionClock",
        title: "Pre-Handled Edition",
        hint: "Lab-onboarded clock: skips the registration QR, then asks the user to connect to Wi-Fi and register",
        fallback: false,
      },
      {
        field: "skippedRegistration",
        title: "Skipped Registration",
        hint: "On blocks the pre-handled registration wizard",
        fallback: false,
      },
    ],
  },
];

/**
 * The device modal's Filters, ECO Mode and Dev card switches that the other
 * profile settings sections don't cover. Same write path as every other
 * profile setting: a key lands in `values` only once it is toggled.
 */
const ExtraSettings = ({ values, onChange }: SettingsSectionProps) => (
  <DSBox>
    {SECTIONS.map((section) => (
      <DSBox key={section.title} sx={{ mb: 1 }}>
        <DSTypography variant="subtitle2" sx={{ fontWeight: 700, mt: 1 }}>
          {section.title}
        </DSTypography>
        {section.settings.map((setting) => (
          <DSBox
            key={setting.field}
            title={setting.hint}
            sx={{ display: "flex", ml: "20px" }}
          >
            <SimpleSwitch
              title={setting.title}
              on={undefined}
              default={
                values[setting.field] !== undefined
                  ? !!values[setting.field]
                  : setting.fallback
              }
              onClick={(on) => onChange(setting.field, on)}
            />
          </DSBox>
        ))}
      </DSBox>
    ))}
  </DSBox>
);

export default ExtraSettings;
